export const experienceData = [
    {
        id: 1,
        company: 'SecureNext Solutions',
        jobtitle: 'Software Engineer',
        startYear: 'Aug 2025',
        endYear: 'Current'
    },
    {
        id: 2,
        company: 'Clar Technologies',
        jobtitle: 'Software Developer',
        startYear: 'Apr 2025',
        endYear: 'Current'
    },
    {
        id: 3,
        company: 'EDUFIED',
        jobtitle: 'Frontend Developer',
        startYear: 'Dec 2023',
        endYear: 'July 2024'
    },
    {
        id: 4,
        company: 'LUMOS IND',
        jobtitle: 'Research Associate',
        startYear: 'Aug 2020',
        endYear: 'Jan 2021'
    },
    
    
]
